/* eslint-disable react-hooks/exhaustive-deps */
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { debounce } from 'lodash'
import { FC, useCallback, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { territoriesActions } from 'src/ducks/actions'
import { getTerritories } from 'src/ducks/selectors'
import { VendorTerritory } from 'src/ducks/types'
import { REVIEW_STATUS } from 'src/helpers'
import { Box, Checkbox, FormControlLabel, InputSearch, TextField, Typography } from '../../../../../UI'
import { VendorContext } from '../../context'

const TableColumn: FC<{ data: VendorTerritory[] }> = ({ data }) => {
  const { editedVendor, setEditedVendor } = useContext(VendorContext)
  const lay = { '&:last-child td, &:last-child th': { border: 0 } }
  const min = 0
  const max = 20

  return (
    <Table sx={{ border: 0 }}>
      <TableHead>
        <TableRow key={'head'} sx={lay}>
          <TableCell>Territory</TableCell>
          <TableCell>Allow Pre-list</TableCell>
          <TableCell>Allow Pre-sale</TableCell>
          <TableCell>Min Amount</TableCell>
          <TableCell>Capacity (# of crews)</TableCell>
        </TableRow>
      </TableHead>
      <TableBody sx={lay}>
        {data.map((row: VendorTerritory, index: number) => (
          <TableRow key={index + row.id} sx={lay}>
            {row.id === "OTHER" && <TableCell sx={lay}>
              <FormControlLabel
                label={<TextField
                  placeholder='Other'
                  disabled={!editedVendor?.territoryList?.some(t => t.id === row.id)}
                  value={editedVendor?.territoryList?.find(t => t.id === "OTHER")?.title}
                  onChange={(event) => {
                    setEditedVendor({
                      ...editedVendor,
                      territoryList: editedVendor?.territoryList?.map(t => {
                        if (t.id === "OTHER") {
                          return {
                            ...t,
                            id: "OTHER",
                            title: event.target.value
                          }
                        }
                        return t
                      })
                    })
                  }}
                />}
                control={
                  <Checkbox
                    checked={editedVendor?.territoryList?.some(t => t.id === row.id)}
                    onChange={(event) => {
                      if (!event.target.checked) {
                        setEditedVendor({
                          ...editedVendor,
                          territoryList: editedVendor?.territoryList?.filter(t => t.id !== row.id)
                        })
                      } else {
                        const newTerritories = editedVendor?.territoryList
                        newTerritories?.push(row)
                        setEditedVendor({
                          ...editedVendor,
                          territoryList: newTerritories
                        })
                      }
                    }}
                    color='infoText'
                  />
                }
              />
            </TableCell>}
            {row.id !== "OTHER" && <TableCell sx={lay}>
              <FormControlLabel
                label={<Typography variant='body2'>{row.title ?? ''}</Typography>}
                control={
                  <Checkbox
                    checked={editedVendor?.territoryList?.some(t => t.id === row.id)}
                    onChange={(event) => {
                      if (!event.target.checked) {
                        setEditedVendor({
                          ...editedVendor,
                          territoryList: editedVendor?.territoryList?.filter(t => t.id !== row.id)
                        })
                      } else {
                        const newTerritories = editedVendor?.territoryList
                        newTerritories?.push(row)
                        setEditedVendor({
                          ...editedVendor,
                          territoryList: newTerritories
                        })
                      }
                    }}
                    color='infoText'
                  />
                }
              />
            </TableCell>}
            {row.id !== "OTHER" &&
              <TableCell sx={lay}>
                <Checkbox
                  disabled={!editedVendor?.territoryList?.some(t => t.id === row.id)}
                  checked={!!editedVendor?.territoryList?.find(t => t.id === row.id)?.preListEnabled}
                  onChange={(e) => {
                    const newTerritoryList = editedVendor?.territoryList?.map(t => {
                      if (t.id === row.id) {
                        return {
                          ...t,
                          preListEnabled: e.target.checked
                        }
                      }
                      return t
                    })
                    setEditedVendor({
                      ...editedVendor,
                      territoryList: newTerritoryList
                    })
                  }}
                  color='infoText'
                />
              </TableCell>
            }
            {row.id !== "OTHER" &&
              <TableCell sx={lay}>
                <Checkbox
                  disabled={!editedVendor?.territoryList?.some(t => t.id === row.id)}
                  checked={!!editedVendor?.territoryList?.find(t => t.id === row.id)?.preSaleEnabled}
                  onChange={(e) => {
                    const newTerritoryList = editedVendor?.territoryList?.map(t => {
                      if (t.id === row.id) {
                        return {
                          ...t,
                          preSaleEnabled: e.target.checked
                        }
                      }
                      return t
                    })
                    setEditedVendor({
                      ...editedVendor,
                      territoryList: newTerritoryList
                    })
                  }}
                  color='infoText'
                />
              </TableCell>
            }
            {row.id !== "OTHER" &&
              <TableCell sx={lay}>
                <TextField
                  type='number'
                  size='small'
                  disabled={!editedVendor?.territoryList?.some(t => t.id === row.id)}
                  value={editedVendor?.territoryList?.find(t => t.id === row.id) ? editedVendor?.territoryList?.find(t => t.id === row.id)?.jobMinimum ?? '' : ''}
                  variant='outlined'
                  placeholder='Min amount'
                  inputProps={{ min: 0 }}
                  style={{ minWidth: '150px' }}
                  onChange={(e) => {
                    const value = e.target.value === '' ? null : Math.max(0, parseInt(e.target.value, 10))
                    const newTerritoryList = editedVendor?.territoryList?.map(t => {
                      if (t.id === row.id) {
                        return {
                          ...t,
                          jobMinimum: value
                        }
                      }
                      return t
                    })
                    setEditedVendor({
                      ...editedVendor,
                      territoryList: newTerritoryList
                    })
                  }}
                />
              </TableCell>
            }
            {row.id !== "OTHER" &&
              <TableCell sx={lay}>
                <TextField
                  type='number'
                  size='small'
                  disabled={!editedVendor?.territoryList?.some(t => t.id === row.id)}
                  value={editedVendor?.territoryList?.find(t => t.id === row.id) ? editedVendor?.territoryList?.find(t => t.id === row.id)?.capacity : ''}
                  variant='outlined'
                  placeholder={`From ${min} to ${max}`}
                  inputProps={{ min, max }}
                  style={{ minWidth: '212px' }}
                  onChange={(e) => {
                    var value = parseInt(e.target.value, 10)
                    if (value > max) value = max
                    if (value < min) value = min
                    const newTerritoryList = editedVendor?.territoryList?.map(t => {
                      if (t.id === row.id) {
                        return {
                          ...t,
                          capacity: value
                        }
                      }
                      return t
                    })
                    setEditedVendor({
                      ...editedVendor,
                      territoryList: newTerritoryList

                    })
                  }}
                />
              </TableCell>
            }
          </TableRow>
        ))}
      </TableBody>
    </Table >
  )
}

const Territories: FC = () => {
  const dispatch = useDispatch()

  const { editedVendor, setEditedVendor } = useContext(VendorContext)
  const territoryList = useSelector(getTerritories)
  const [all, setAll] = useState<VendorTerritory[] | undefined>([])
  const [searchValue, setSearchValue] = useState('')

  const dispatchSearch = useCallback((value: string) => {
    dispatch(
      territoriesActions.fetchTerritories({ searchParams: value ? { search: value } : {} }, () => { })
    )
  }, [dispatch])

  const debouncedSearch = useCallback(debounce(dispatchSearch, 500), [dispatchSearch])

  useEffect(() => {
    dispatch(
      territoriesActions.fetchTerritories({}, () => { })
    )
  }, [dispatch])

  useEffect(() => {
    const rows: VendorTerritory[] = territoryList.map(t => {
      const vendorTerritory = editedVendor?.territoryList?.find(territory => territory.id === t.id)

      return {
        id: t.id,
        title: t.title,
        status: REVIEW_STATUS.APPROVED,
        capacity: null,
        validGL: vendorTerritory?.validGL || false,
        validWC: vendorTerritory?.validWC || false,
        preListEnabled: false,
        preSaleEnabled: false,
        jobMinimum: null
      }
    })
    const other = editedVendor?.territoryList?.find(territory => territory.id === "OTHER")
    if (other) {
      rows.push({
        id: other.id,
        title: other.title,
        status: REVIEW_STATUS.DRAFT,
        capacity: 0,
        validGL: false,
        validWC: false,
        preListEnabled: false,
        preSaleEnabled: false,
        jobMinimum: null
      })
    } else {
      rows.push({
        id: "OTHER",
        title: "",
        status: REVIEW_STATUS.DRAFT,
        capacity: 0,
        validGL: false,
        validWC: false,
        preListEnabled: false,
        preSaleEnabled: false,
        jobMinimum: null
      })
    }
    setAll(rows)

  }, [territoryList])

  const allChecked = (all ?? []).length > 0 &&
    (all ?? []).every(row => editedVendor?.territoryList?.some(t => t.id === row.id))
  const someChecked = (all ?? []).some(row => editedVendor?.territoryList?.some(t => t.id === row.id))

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      const existingIds = new Set(editedVendor?.territoryList?.map(t => t.id))
      const toAdd = (all ?? []).filter(row => !existingIds.has(row.id))
      setEditedVendor({
        ...editedVendor,
        territoryList: [...(editedVendor?.territoryList ?? []), ...toAdd]
      })
    } else {
      const displayedIds = new Set((all ?? []).map(row => row.id))
      setEditedVendor({
        ...editedVendor,
        territoryList: editedVendor?.territoryList?.filter(t => !displayedIds.has(t.id))
      })
    }
  }

  return (
    <Box display='flex' flexDirection='column' gap={1}>
      <Box display='flex' alignItems='center' gap={2}>
        <InputSearch
          placeholder='Search by Territory Title'
          value={searchValue}
          onChange={(value: string) => {
            setSearchValue(value)
            debouncedSearch(value)
          }}
          sx={{ minWidth: '220px' }}
        />
        <FormControlLabel
          label='Select All'
          control={
            <Checkbox
              checked={allChecked}
              indeterminate={!allChecked && someChecked}
              onChange={(e) => handleSelectAll(e.target.checked)}
              color='infoText'
            />
          }
        />
      </Box>
      <TableColumn data={all ?? []} />
    </Box>
  )
}

export default Territories
